import { createComponent } from '@/helpers/alpine';
import { getBreakpoint } from '@/helpers/style';

const productScrollbar = createComponent(() => ({
    isScrolled: false,

    init() {
        this.checkScroll();
        window.addEventListener('scroll', () => {
            this.checkScroll();

            document.body.classList.toggle('pb-[72px]', this.isScrolled);
        });
    },

    checkScroll() {
        const header = document.querySelector('header') as HTMLElement;
        const buttonWrapper = document.querySelector(
            '.js-product-add-to-cart-wrapper',
        ) as HTMLElement;
        if (!header || !buttonWrapper) return;

        const headerRect = header.getBoundingClientRect();
        const buttonRect = buttonWrapper.getBoundingClientRect();

        this.isScrolled = headerRect.bottom - 65 >= buttonRect.top;

        if (this.isScrolled && !getBreakpoint('sm'))
            buttonWrapper.classList.add('h-[134px]');
        else if (this.isScrolled && getBreakpoint('sm'))
            buttonWrapper.classList.add('h-[66px]');
        else buttonWrapper.classList.remove('h-[66px]', 'h-[134px]');
    },
}));

export { productScrollbar };
